import React from 'react';

interface Slice {
  value: number;
  color: string;
  label?: string;
}

interface DoughnutChartProps {
  data: Slice[];
  size?: number;
  thickness?: number;
  className?: string;
}

export function DoughnutChart({ data, size = 200, thickness = 40, className }: DoughnutChartProps) {
  const total = data.reduce((sum, s) => sum + s.value, 0);
  if (total === 0) return null;

  const cx = size / 2;
  const cy = size / 2;
  const r = (size - thickness) / 2;

  let cumulativePercent = 0;
  const slices = data.map((slice) => {
    const percent = slice.value / total;
    const startAngle = cumulativePercent * 2 * Math.PI - Math.PI / 2;
    const endAngle = (cumulativePercent + percent) * 2 * Math.PI - Math.PI / 2;
    cumulativePercent += percent;

    const x1 = cx + r * Math.cos(startAngle);
    const y1 = cy + r * Math.sin(startAngle);
    const x2 = cx + r * Math.cos(endAngle);
    const y2 = cy + r * Math.sin(endAngle);
    const largeArc = percent > 0.5 ? 1 : 0;

    return {
      ...slice,
      path: `M ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2}`,
    };
  });

  return (
    <svg width={size} height={size} className={className} viewBox={`0 0 ${size} ${size}`}>
      {slices.map((slice, i) => (
        <path
          key={i}
          d={slice.path}
          fill="none"
          stroke={slice.color}
          strokeWidth={thickness}
          strokeLinecap="butt"
        />
      ))}
    </svg>
  );
}
